export default "__VITE_ASSET__CJdh7nM7__"